import React, { useState } from "react";

const IOCard = ({ tag, latestMap, onSetAnalog }) => {
  const latest = latestMap?.[tag.name];

  const numeric =
    latest && latest.last_value !== null && latest.last_value !== undefined && !isNaN(latest.last_value)
      ? Number(latest.last_value)
      : null;

  const currentText = numeric !== null ? numeric.toFixed(2) : "N/A";
  const ts = latest?.timestamp ?? "N/A";

  const [inputValue, setInputValue] = useState("");
  const [sending, setSending] = useState(false);
  const [localErr, setLocalErr] = useState("");

  const submit = async () => {
    setLocalErr("");
    if (inputValue === "" || isNaN(inputValue)) {
      setLocalErr("عدد معتبر وارد کن");
      return;
    }

    setSending(true);
    try {
      await onSetAnalog(tag.id, Number(inputValue));
      setInputValue("");
    } catch (e) {
      setLocalErr("ارسال مقدار ناموفق بود");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="dg-card">
      <div className="dg-card-head">
        <div className="dg-card-title">{tag.name}</div>
        <div className="dg-card-sub">ID: {tag.id}</div>
      </div>

      <div className="dg-row">
        <span className="dg-label">Current</span>
        <span className="dg-value-strong">{currentText}</span>
      </div>

      <div className="dg-io">
        <input
          className="dg-input"
          placeholder="Set value..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <button className="dg-btn" onClick={submit} disabled={sending || inputValue === ""}>
          {sending ? "Sending..." : "Set"}
        </button>
      </div>

      {localErr && <div className="dg-local-error">{localErr}</div>}

      <div className="dg-row">
        <span className="dg-label">Timestamp</span>
        <span className="dg-value-soft">{ts}</span>
      </div>
    </div>
  );
};

export default IOCard;